// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"122":"intro","217":"archive","348":"chat"}[chunkId] + "." + {"122":"ad91da4b","217":"d72f0a3b","348":"d8035285"}[chunkId] + ".js";
};